export default function trackWatchedSection({
  watchedSections,
  getCurrentPosition,
}: {
  watchedSections: Section[];
  getCurrentPosition: () => number;
}) {
  return (position = null) => {
    // Use nullish coalescing so 0 is respected as a valid position
    const currentPosition =
      (position as number | null) ?? Math.floor(getCurrentPosition());
    const watchedSectionsLastItemIdx = watchedSections.length - 1;
    if (
      watchedSections.length &&
      watchedSections[watchedSectionsLastItemIdx].end === -1
    ) {
      watchedSections[watchedSectionsLastItemIdx].end = currentPosition;
    } else {
      watchedSections.push({
        start: currentPosition,
        end: -1,
      });
    }
  };
}

export type Section = {
  start: number;
  end: number;
};
